import { motion } from 'framer-motion';
import clsx from 'clsx';

interface RatingInputProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
}

export default function RatingInput({ value, onChange, max = 10 }: RatingInputProps) {
  const ratings = Array.from({ length: max }, (_, i) => i + 1);

  return (
    <div className="flex flex-wrap justify-center gap-2">
      {ratings.map((rating) => (
        <motion.button
          key={rating}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onChange(rating)}
          className={clsx(
            'w-12 h-12 rounded-xl font-semibold text-lg',
            'transition-all duration-200',
            'border-2',
            value === rating
              ? 'border-primary-500 bg-primary-500/20 text-primary-400 shadow-glow'
              : 'border-dark-700 bg-dark-800 text-dark-300 hover:border-primary-500/50 hover:text-primary-400'
          )}
        >
          {rating}
        </motion.button>
      ))}
    </div>
  );
}
